import { create } from 'zustand';
import { Stage } from '../constants/progress';

export const useProgressStore = create((set) => ({
  // State for each geometry type
  sitePlots: {
    stage: Stage.IDLE,
    message: '',
    fetched: 0,
    processed:0,
    created: 0,
    progress: 0, // 0-100
    error: null
  },
  buildings: {
    stage: Stage.IDLE,
    message: '',
    fetched: 0,
    processed:0,
    created: 0,
    progress: 0,
    error: null
  },
  topography: {
    stage: Stage.IDLE,
    message: '',
    fetched: 0,
    processed:0,
    created: 0,
    progress: 0,
    error: null
  },
  riskarea: {
    stage: Stage.IDLE,
    message: '',
    fetched: 0,
    processed:0,
    created: 0,
    progress: 0,
    error: null
  },
   landuse: {
    stage: Stage.IDLE,
    message: '',
    fetched: 0,
    processed:0,
    created: 0,
    progress: 0,
    error: null
  },
   bplan: {
    stage: Stage.IDLE,
    message: '',
    fetched: 0,
    processed:0,
    created: 0,
    progress: 0,
    error: null
  },


  // Update any geometry type
  updateProgress: (geometryType, updates) => {
    set((state) => ({
      [geometryType]: {
        ...state[geometryType],
        ...updates
      }
    }));
  },

  // Reset a geometry type
  reset: (geometryType) => {
    set((state) => ({
      [geometryType]: {
        stage: Stage.IDLE,
        message: '',
        fetched: 0,
        processed:0,
        created: 0,
        progress: 0,
        error: null
      }
    }));
  },

  // Reset all
  resetAll: () => {
    set({
      sitePlots: { stage: Stage.IDLE, message: '',fetched: 0, processed:0, created: 0, progress: 0, error: null },
      buildings: { stage: Stage.IDLE, message: '',fetched: 0, processed:0, created: 0, progress: 0, error: null },
      topography: { stage: Stage.IDLE, message: '',fetched: 0, processed:0, created: 0, progress: 0, error: null },
      riskarea: { stage: Stage.IDLE, message: '',fetched: 0, processed:0, created: 0, progress: 0, error: null },
      landuse: { stage: Stage.IDLE, message: '',fetched: 0, processed:0, created: 0, progress: 0, error: null },
      bplan: { stage: Stage.IDLE, message: '',fetched: 0, processed:0, created: 0, progress: 0, error: null }
    });
  }
}));